<template>
  <Grid gap="var(--r-space-md)" class="email-template-editor">
    <Grid gtc="auto 1fr" gap="var(--r-space-sm)" align-items="center">
      <div class="text-body-1 text-grey3">Subject:</div>
      <RInput v-model="subject" no-hint no-label no-feedback-icon @input="$emit('subject-input', subject)" />
    </Grid>

    <q-editor
      ref="editor"
      v-model="content"
      :content-style="{ listStylePosition: 'inside' }"
      :fonts="Q_EDITOR_MIXIN_fonts"
      :toolbar="[['merge_tags'], ...Q_EDITOR_MIXIN_toolbarSettings]"
      toolbar-rounded
      max-height="250px"
      toolbar-toggle-color="primary-1"
      @input="input"
      @hook:mounted="editorMounted"
      @paste.native="Q_EDITOR_MIXIN_onPaste"
    >
      <template v-slot:merge_tags>
        <q-btn-dropdown
          v-if="mergeTags.length > 0"
          ref="mergeTagsDropdown"
          slot="merge_tags"
          flat
          dense
          no-caps
          size="sm"
          icon="fas fa-tags"
          label="Merge tags"
        >
          <q-list>
            <q-item
              v-for="(tag, index) of mergeTags"
              :key="`tag_${index}`"
              v-close-popup
              separator
              class="cursor-pointer"
              @click.native="insertTag(tag)"
            >
              <q-item-label>
                <q-item-section label>{{ tag.name }}</q-item-section>
                <q-item-section sublabel>{{ tag.description }}</q-item-section>
              </q-item-label>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </q-editor>

    <p class="text-body-4 text-warning-1">
      If there are merge tags in the template, please do not remove the square brackets [[ ]] surrounding those as the
      system uses them to recognize and replace the merge tags with content.
    </p>
  </Grid>
</template>

<script>
import Q_EDITOR_MIXIN from '@/mixins/q-editor-mixin'

export default {
  name: 'EmailTemplateEditor',

  mixins: [Q_EDITOR_MIXIN],

  props: {
    modelContent: {
      type: String,
      default: ''
    },

    modelSubject: {
      type: String,
      default: ''
    },

    mergeTags: {
      type: Array,
      default: () => []
    },

    hideLabels: Boolean
  },

  data() {
    return {
      content: '',
      subject: null
    }
  },

  watch: {
    modelSubject: {
      handler(val) {
        this.subject = val
      },
      immediate: true
    }
  },

  methods: {
    editorMounted() {
      const editor = this.$refs.editor
      editor.$el.addEventListener('keyup', function(event) {
        event.stopPropagation()
      })
      editor.runCmd('insertHTML', `<div>${this.modelContent}</div>`)
      editor.$el.querySelector('.q-editor__content').blur()
      window.getSelection().removeAllRanges()
    },

    input() {
      this.$emit('content-input', this.content)
    },

    insertTag(tag) {
      const editor = this.$refs.editor
      this.$refs.mergeTagsDropdown.hide()
      editor.caret.restore()
      editor.runCmd('insertText', tag.name)
      editor.focus()
    }
  }
}
</script>
